import { createAction } from 'redux-actions';
import types from '../types';

export const showDetailedChartViewFor = createAction(
  types.SHOW_DETAILED_CHART_VIEW
);

export const changeChartDataZoom = createAction(types.CHANGE_CHART_DATAZOOM);
